






import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class Title extends Vue {
  @Prop(Boolean) darken!: boolean

  @Prop({
    type: String,
    required: true
  }) info!: string
}
